import { Routes, Route, useNavigate } from 'react-router-dom';
import ForecastForm from './components/ForecastForm/ForecastForm';
import ForecastProcess from './components/ForecastProcess/ForecastProcess';
import ForecastResults from './components/ForecastResults/ForecastResults';
import { createForecast } from './utils/api';
import './App.css';

function HomePage() {
  const navigate = useNavigate();

  const handleFormSubmit = async (question) => {
    try {
      const result = await createForecast({ market_title: question });
      navigate(`/forecast/${result.forecast_id}/process`);
    } catch (error) {
      console.error('Error during submission:', error);
      throw error;
    }
  };

  return (
    <div className="app">
      <header className="app__header">
        <div className="app__header-content">
          <img src="/logo.png" alt="Propheseer" className="app__logo" />
          <div className="app__header-text">
            <h1 className="app__title">Propheseer</h1>
            <p className="app__subtitle">AI Forecasting</p>
          </div>
        </div>
      </header>

      <main className="app__main">
        <ForecastForm onSubmit={handleFormSubmit} />
      </main>

      <footer className="app__footer">
        <p className="app__footer-text">
          Multi-agent forecasting powered by GPT-5.2, Claude Opus, and DeepSeek
        </p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/forecast/:id/process" element={<ForecastProcess />} />
      <Route path="/forecast/:id" element={<ForecastResults />} />
    </Routes>
  );
}

export default App;
